import { useRouterState } from "@tanstack/react-router";

/**
 * A 2px accent bar sliding along the foot of the top bar while the router loads the next page. It fades in after 150 ms,
 * so navigations that finish sooner show nothing. With reduced motion the bar stands still.
 */
export function NavigationProgress() {
	const isLoading = useRouterState({ select: state => state.isLoading });
	if (!isLoading) {
		return null;
	}
	return (
		<div
			role="progressbar"
			aria-label="Loading page"
			className="pointer-events-none absolute inset-x-0 -bottom-px h-0.5 animate-fade-in overflow-hidden"
		>
			<div className="h-full w-2/5 animate-progress rounded-pill bg-accent motion-reduce:w-full motion-reduce:animate-none motion-reduce:opacity-60" />
		</div>
	);
}
